import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** The statuses reached only once Finish Pick has run, so the pick's figures are final. */
export const PICK_FINISHED_OR_LATER_SALES_ORDER_STATUS_IDS = [
    SalesOrderStatus.READY_TO_DELIVER,
    SalesOrderStatus.SHIPPED,
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
];
//# sourceMappingURL=pick-finished-or-later-sales-order-status-ids.js.map